import { Question } from "../../types/question";

type ExamSectionQuestionsProps = {
    questions: Question[];
    isExamCompleted: boolean;
    onQuestionSelection: (updatedQuestion: Question) => void;
};

export function ExamSectionQuestions({
    isExamCompleted,
    questions,
    onQuestionSelection,
}: ExamSectionQuestionsProps) {
    function handleAnswerSelection(questionIndex: number, answer: string) {
        // Update the question with the selected answer
        const updatedQuestion = {
            ...questions[questionIndex],
            answer: answer,
        };

        // Call the parent component's callback to update the question
        onQuestionSelection(updatedQuestion);
    }

    return (
        <div className="p-4">
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-3">
                {questions.map((question, index) => (
                    <div
                        key={index}
                        className="border border-gray-100 rounded p-2 bg-white shadow-sm hover:shadow-md transition-shadow"
                    >
                        <div className="flex items-center gap-2 mb-1.5">
                            <div className="bg-primary/10 w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0">
                                <span className="text-primary text-xs font-semibold">
                                    {index + 1}
                                </span>
                            </div>
                            <p className="text-sm text-gray-800 font-medium line-clamp-2">
                                {question.question}
                            </p>
                        </div>

                        <div className="flex items-center gap-4 pl-7">
                            {["Yes", "No", "N/A"].map((answer) => (
                                <label
                                    key={answer}
                                    className="flex items-center gap-1 cursor-pointer"
                                >
                                    <input
                                        type="radio"
                                        className="radio radio-xs radio-success"
                                        checked={question.answer === answer}
                                        onChange={() =>
                                            handleAnswerSelection(index, answer)
                                        }
                                        disabled={isExamCompleted}
                                    />
                                    <span className="text-xs font-medium">
                                        {answer}
                                    </span>
                                </label>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
